export default {"src":"/_next/static/media/bear_strategy.53b1816b.svg","height":25,"width":24};